import { useState } from 'react';
import { ErroreApi } from '../api/cliente.js';
import { useCambiaPassword } from '../api/credenziali.js';
import { t } from '../i18n/lingua.js';

/**
 * Cambiarsi la password.
 *
 * Nel v2 non si può fare affatto: l'unica strada è il link di ripristino, che
 * è rotto. Qui si chiede quella di adesso — senza, chiunque trovi un computer
 * sbloccato si prende l'utenza.
 *
 * Sta nel profilo e non più in una finestra appesa al menu dell'avatar: la
 * password è una delle cose per cui si va nelle impostazioni, ed è lì che la
 * gente la cerca.
 */
export function SchedaPassword() {
  const [attuale, setAttuale] = useState('');
  const [nuova, setNuova] = useState('');
  const [conferma, setConferma] = useState('');
  const [fatta, setFatta] = useState(false);
  const cambia = useCambiaPassword();

  const errore = cambia.error instanceof ErroreApi ? cambia.error : null;
  const diverse = conferma.length > 0 && nuova !== conferma;
  // la ripetizione deve esserci ed essere uguale: lasciata vuota, la password
  // cambiava senza essere stata scritta due volte
  const pronta = attuale.length > 0 && nuova.length >= 8 && nuova === conferma;

  const applica = () =>
    cambia.mutate(
      { currentPassword: attuale, newPassword: nuova },
      {
        onSuccess: () => {
          // i campi si svuotano: lasciarli pieni fa credere che ci sia ancora
          // qualcosa da salvare
          setAttuale('');
          setNuova('');
          setConferma('');
          setFatta(true);
        },
      },
    );

  return (
    <div className="card">
      <div className="card-head">
        <span className="card-title">{t('Password')}</span>
      </div>
      <div className="card-body">
        {errore && (
          <div className="avviso" role="alert" style={{ marginBottom: 12 }}>
            <span className="avviso-segno">▲</span>
            <span>{errore.message}</span>
          </div>
        )}
        {fatta && !errore && (
          <div className="avviso" role="status" style={{ marginBottom: 12 }}>
            <span className="avviso-segno">i</span>
            <span>{t('La password è cambiata. Ti è arrivato anche un messaggio che lo conferma.')}</span>
          </div>
        )}

        <div className="fields">
          <div className="field span-2">
            <label htmlFor="pw-attuale">{t('Password di adesso')}</label>
            <input
              className="input"
              id="pw-attuale"
              type="password"
              autoComplete="current-password"
              value={attuale}
              onChange={(e) => {
                setAttuale(e.target.value);
                setFatta(false);
              }}
            />
          </div>
          <div className="field">
            <label htmlFor="pw-nuova">{t('Password nuova')}</label>
            <input
              className="input"
              id="pw-nuova"
              type="password"
              autoComplete="new-password"
              minLength={8}
              value={nuova}
              onChange={(e) => setNuova(e.target.value)}
            />
            <span className="hint">{t('Almeno otto caratteri.')}</span>
          </div>
          <div className="field">
            <label htmlFor="pw-conferma">{t('Ripetila')}</label>
            <input
              className="input"
              id="pw-conferma"
              type="password"
              autoComplete="new-password"
              value={conferma}
              onChange={(e) => setConferma(e.target.value)}
            />
            {diverse && (
              <span className="hint" style={{ color: 'var(--tomato)' }}>
                {t('Le due password non coincidono.')}
              </span>
            )}
          </div>
        </div>

        <button
          className="btn btn-primary"
          style={{ marginTop: 12 }}
          disabled={!pronta || cambia.isPending}
          onClick={applica}
        >
          {cambia.isPending ? t('Un momento…') : t('Cambia la password')}
        </button>

        <p className="dim" style={{ fontSize: 13, marginBottom: 0, marginTop: 10 }}>
          {t('Cambiarla non butta fuori le altre sessioni aperte: per quelle c’è «Sessioni aperte». Si chiudono da sole solo se la password la rifà un amministratore, o se la ripristini dal link.')}
        </p>
      </div>
    </div>
  );
}
